import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e9954666"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
import StudyMaterialDetailTop from "@/components/studyMaterial/detail/StudyMaterialDetailTop.vue";
import StudyMaterialDetailContent from "@/components/studyMaterial/detail/StudyMaterialDetailContent.vue";
import StudyMaterialDetailRight from "@/components/studyMaterial/detail/StudyMaterialDetailRight.vue";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useLoginUserStore } from "@/store/loginUser";
import { XiaoniuStudyMaterialControllerService } from "../../generated/services/XiaoniuStudyMaterialControllerService";
export default /*#__PURE__*/_defineComponent({
  __name: 'StudyMaterialDetail',
  setup(__props) {
    const route = useRoute();
    const loginUserStore = useLoginUserStore();
    const materialDetail = ref({});
    const viewCount = ref(0);
    const buyCount = ref(0);
    const materialTopFiveList = ref([]);
    // 模拟数据兜底 - 用于接口异常/无数据时展示，方便测试下单流程
    const mockDetail = {
      id: 100002,
      name: 'Java面试宝典·大厂真题集',
      coverImage: '',
      price: 19.9,
      description: '本资料收录了近三年 BAT、字节、京东、美团等大厂 Java 面试真题，按 JVM、多线程、Spring、微服务、中间件、数据库等模块系统整理，每道题都附带详细的答案解析与知识点拓展，助你高效备战大厂面试。',
      detailContent: `## 资料亮点

- 🎯 **覆盖全面**：涵盖 Java 基础、JVM、并发、Spring 全家桶、MySQL、Redis、MQ、微服务等核心模块
- � **真题精讲**：200+ 道大厂真实面试题，每题均附答案与扩展知识点
- 🔥 **持续更新**：根据最新面试趋势定期更新内容
- 💡 **配套笔记**：提供作者独家复习笔记与思维导图

## 内容目录

### 一、Java 基础
- 1.1 Java 基本数据类型与包装类
- 1.2 String、StringBuilder、StringBuffer 区别
- 1.3 == 与 equals 的区别
- 1.4 HashMap 原理（扩容、红黑树、扰动函数）

### 二、JVM 专题
- 2.1 JVM 内存模型与运行时数据区
- 2.2 垃圾回收算法与垃圾收集器
- 2.3 类加载机制与双亲委派
- 2.4 调优实战：GC 日志分析与参数配置

### 三、并发编程
- 3.1 volatile 与 JMM 内存模型
- 3.2 synchronized 与锁升级
- 3.3 AQS 与 ReentrantLock 原理
- 3.4 线程池核心参数与最佳实践

### 四、Spring 全家桶
- 4.1 Spring IoC 与 AOP 原理
- 4.2 Spring Bean 生命周期
- 4.3 SpringBoot 自动配置原理
- 4.4 Spring 事务传播机制

> 💬 站长提示：本资料持续更新，购买后凭订单号加站长微信 \`xiaoniuzui6\` 即可加入内部交流群。`,
      downloadUrl: '',
      introUrl: 'https://mp.weixin.qq.com/s/example-java-interview-guide',
      viewCount: 5621,
      buyCount: 2304,
      createTime: '2025-09-02 10:30:00',
      remark: '测试用模拟数据'
    };
    const mockTopFive = [{
      id: 100006,
      name: '计算机网络学习笔记',
      viewCount: 9234
    }, {
      id: 100003,
      name: '软件设计师中级历年真题',
      viewCount: 7823
    }, {
      id: 100002,
      name: 'Java面试宝典·大厂真题集',
      viewCount: 5621
    }, {
      id: 100007,
      name: '前端面试必备·Vue3核心原理',
      viewCount: 4321
    }, {
      id: 100001,
      name: '2025考研英语高频词汇精选',
      viewCount: 3856
    }];
    const getMaterialDetail = async () => {
      const id = Number(route.params.id);
      if (!id) {
        // 没有 id 时直接用 mock 数据（用于联调测试）
        materialDetail.value = mockDetail;
        viewCount.value = mockDetail.viewCount;
        buyCount.value = mockDetail.buyCount;
        return;
      }
      try {
        const res = await XiaoniuStudyMaterialControllerService.getInfoUsingGet21(id);
        if (res.code === 200 && res.data && Object.keys(res.data).length > 0) {
          materialDetail.value = res.data;
        } else {
          // 接口无数据，使用模拟数据
          console.info('StudyMaterialDetail: 接口无数据，使用模拟数据');
          materialDetail.value = mockDetail;
          viewCount.value = mockDetail.viewCount;
          buyCount.value = mockDetail.buyCount;
        }
      } catch (error) {
        console.warn('获取资料详情失败，使用模拟数据:', error);
        materialDetail.value = mockDetail;
        viewCount.value = mockDetail.viewCount;
        buyCount.value = mockDetail.buyCount;
      }
    };
    // 添加浏览量
    const addView = async () => {
      const id = Number(route.params.id);
      if (!id) return;
      try {
        if (loginUserStore.isLogin) {
          await XiaoniuStudyMaterialControllerService.addViewUsingPost(id);
        }
        await getViewCount();
      } catch (error) {
        console.error('添加浏览量失败:', error);
      }
    };
    const getViewCount = async () => {
      const id = Number(route.params.id);
      if (!id) return;
      try {
        const res = await XiaoniuStudyMaterialControllerService.getInfoUsingGet21(id);
        if (res.code === 200 && res.data) {
          viewCount.value = res.data?.viewCount || 0;
          buyCount.value = res.data?.buyCount || 0;
        }
      } catch (error) {
        console.error('获取统计信息失败:', error);
      }
    };
    const getTopFive = async () => {
      try {
        const res = await XiaoniuStudyMaterialControllerService.topFiveUsingPost();
        if (res.code === 200 && res.data && res.data.length > 0) {
          materialTopFiveList.value = res.data;
        } else {
          materialTopFiveList.value = mockTopFive;
        }
      } catch (error) {
        console.warn('获取热门资料失败，使用模拟数据:', error);
        materialTopFiveList.value = mockTopFive;
      }
    };
    // 子组件下单成功后，重新拉取最新买量（免费资料后端已 +1）
    const handleOrderSuccess = async () => {
      await getViewCount();
    };
    onMounted(() => {
      getMaterialDetail();
      addView();
      getTopFive();
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 24,
          style: {
            "transition": "all .5s ease-out"
          }
        }, {
          default: _withCtx(() => [_createVNode(StudyMaterialDetailTop, {
            "material-detail": materialDetail.value,
            "view-count": viewCount.value,
            "buy-count": buyCount.value,
            onOrderSuccess: handleOrderSuccess
          }, null, 8, ["material-detail", "view-count", "buy-count"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        gutter: 30
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 16,
          style: {
            "transition": "all .5s ease-out",
            "margin-bottom": "30px"
          }
        }, {
          default: _withCtx(() => [_createVNode(StudyMaterialDetailContent, {
            "material-detail": materialDetail.value
          }, null, 8, ["material-detail"])]),
          _: 1
        }), _createVNode(_component_el_col, {
          sm: 24,
          md: 8
        }, {
          default: _withCtx(() => [_createVNode(StudyMaterialDetailRight, {
            "material-top-five-list": materialTopFiveList.value
          }, null, 8, ["material-top-five-list"])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});